import LocationInformation from 'components/pages/ShiftPage/TruckSectionContent/LocationInformation'
import ButtonLink from 'components/ui/ButtonLink'
import Link from 'next/link'
import pathFromUrl from 'utils/pathFromUrl'
import LinksSection, {
  HeroLinksType
} from 'components/HeroSection/LinksSection'
import TruckNameSection from 'components/HeroSection/TruckNameSection'
import Rating from 'components/HeroSection/Rating'
import { TruckInformationFragment } from 'components/HeroSection/types/TruckInformationFragment'
import PreviousPageLink from 'components/PreviousPageLink'

import { LocationInformationFragment as locationInformationFragmentType } from './types/LocationInformationFragment'

const TruckSectionContent = ({
  scheduleUrl,
  truckName,
  location,
  socialLinks,
  preferredVendor,
  preferredVendorBadge,
  instantBook,
  ratingInfo
}: {
  scheduleUrl: string
  truckName: string
  location: locationInformationFragmentType
  socialLinks: HeroLinksType
  preferredVendor: boolean
  preferredVendorBadge: string | null
  ratingInfo: TruckInformationFragment['ratingInfo']
  instantBook: boolean
}) => {
  return (
    <div>
      <div className="flex flex-col my-2 lg:my-6">
        <PreviousPageLink />
        <TruckNameSection
          instantBook={instantBook}
          name={truckName}
          preferredVendor={preferredVendor}
          preferredVendorBadge={preferredVendorBadge}
        />
        <Rating ratingInfo={ratingInfo} />
        <Link
          className="underline text-gray-100 lg:hidden block"
          href={pathFromUrl(scheduleUrl)}
          prefetch={false}
        >
          Truck&apos;s Schedule
        </Link>
      </div>
      <div className="flex sm:mb-4 mt-0 w-12 sm:w-auto items-center">
        <div className="hidden sm:block">
          <LinksSection socialLinks={socialLinks} />
        </div>
        <div className="lg:block hidden ml-2">
          <ButtonLink
            color="secondary"
            href={pathFromUrl(scheduleUrl)}
            prefetch={false}
            size="small"
            variant="transparent"
          >
            Truck&apos;s Schedule
          </ButtonLink>
        </div>
      </div>
      <LocationInformation hideOrdersProgress={false} location={location} />
    </div>
  )
}

export default TruckSectionContent
